<script lang="tsx" setup>
import { setWindowTitle } from "@zyzgroup/core-web";
import Page from "../base/Page.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Page },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    src?: string; // encodeURIComponent("https://erichd2.oss-cn-shanghai.aliyuncs.com/0000/0002/2159")
    title?: string;
  }>(),
  {
    src: "",
    title: ""
  }
);

setWindowTitle(props.title);
const src = decodeURIComponent(props.src);
</script>

<template>
  <Page>
    <div class="view-document">
      <img
        class="view-document-img"
        :src="src"
      />
    </div>
  </Page>
</template>

<style scoped>
.view-document {
  box-sizing: border-box;
  width: 100%;
  padding: var(--yz-padding-horizontal, 15px);
}
.view-document-img {
  width: 100%;
}
</style>
